/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { quotationQueryKeys } from "./quotationQueryKeys";

type useQuotationListsProps = {
  shipmentId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};
export const useQuotationLists = (data: useQuotationListsProps) =>
  useQuery<any>({
    queryKey: quotationQueryKeys.quotationList(data.shipmentId),
    queryFn: data.queryFn,
    ...data.options,
  });
